/**
 * @file
 */

import mainNavigation from './mainNavigation.js'
import pauseAnimation from './pauseAnimation.js'
import tableStacked from './tableStacked.js'

((Drupal, once) => {
  mainNavigation(Drupal, once)
  pauseAnimation(Drupal, once)
  tableStacked(Drupal, once)
})(Drupal, once)
